function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FF8E2E",
  d: "M125.8 1H4.2A3.2 3.2 0 001 4.2v121.6a3.2 3.2 0 003.2 3.2h121.6a3.2 3.2 0 003.2-3.2V4.2a3.2 3.2 0 00-3.2-3.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M89.598 61.42l-.43-.888-.718-.564c-.939-.734-5.688.05-6.966-1.114-.909-.835-1.049-2.336-1.322-4.369-.51-3.95-.835-4.154-1.449-5.487-2.237-4.749-8.303-8.319-12.471-8.812h-11.29c-8.883 0-16.143 7.274-16.143 16.157v18.843c0 8.867 7.26 16.127 16.143 16.127H73.5c8.883 0 16.098-7.26 16.147-16.127l.101-13.051-.15-.715zm-34.441-8.034h8.952a3.091 3.091 0 013.091 3.082 3.102 3.102 0 01-3.091 3.09h-8.952a3.102 3.102 0 01-3.092-3.09 3.091 3.091 0 013.092-3.082zm18.189 24.636H55.157c-1.709 0-3.092-1.404-3.092-3.077 0-1.692 1.383-3.07 3.092-3.07h18.188a3.076 3.076 0 013.076 3.07c.001 1.673-1.378 3.077-3.075 3.077z"
});

function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
}

export default SvgBlog;